import Link from 'next/link';
import { NextRouter, useRouter } from 'next/router';
import { Layout } from '../components/common';
import Head from 'next/head';

function getNotFoundWording(pathname: string) {
  switch (pathname) {
    case '/[teamSlug]/[campaignSlug]/types/[typeSlug]':
      return 'Custom type';
    case '/[teamSlug]/[campaignSlug]':
      return 'Campaign';
    case '/[teamSlug]':
      return 'Team';
    default:
      return 'Page';
  }
}

function getGoBackHref(router: NextRouter) {
  const { teamSlug, campaignSlug } = router.query;
  switch (router.pathname) {
    case '/[teamSlug]/[campaignSlug]/types/[typeSlug]':
      return `/${teamSlug}/${campaignSlug}`;
    case '/[teamSlug]/[campaignSlug]':
      return `/${teamSlug}`;
    case '/[teamSlug]':
      return '/';
    default:
      return '/';
  }
}

function getGoBackWording(pathname: string) {
  switch (pathname) {
    case '/[teamSlug]/[campaignSlug]/types/[typeSlug]':
      return 'to Campaign';
    case '/[teamSlug]/[campaignSlug]':
      return 'to Team';
    default:
      return 'to main Team';
  }
}

export default function Custom404() {
  const router = useRouter();

  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Layout title="Not found" pageProps={{}}>
        <div className="bg-white min-h-full flex-1 px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
          <div className="max-w-max mx-auto">
            <main className="sm:flex">
              <p className="text-4xl font-extrabold text-rum-600 sm:text-5xl">
                404
              </p>
              <div className="sm:ml-6">
                <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                  <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                    {getNotFoundWording(router.pathname)} not found
                  </h1>
                  <p className="mt-1 text-base text-gray-500">
                    Please check the URL in the address bar and try again.
                  </p>
                </div>
                <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                  <Link
                    href={getGoBackHref(router)}
                    passHref
                    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-rum-600 hover:bg-rum-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rum-500"
                  >
                    Go back{getGoBackWording(router.pathname)}
                  </Link>
                </div>
              </div>
            </main>
          </div>
        </div>
      </Layout>
    </>
  );
}
